import React from 'react';

//@ts-ignore
import * as styles from './product-detail-masthead.module.css';
//@ts-ignore
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { MediaQueries } from '../Global/GlobalMediaQueries';
import { ContentPosition, ProductDetailProps, VerticalPosition } from './index';
import { getMultiChoice, getColor } from '../Global/DataUtils/index';
import { getFluidImageData } from '../Global/DataUtils/gatsbyImageUtils';
import GatsbyImage from 'gatsby-image/withIEPolyfill';
import PlainTextElement from '../Global/Headlines';

const ProductDetailMasthead: React.FC<ProductDetailProps> = ({
    under_image_bar_show_hide,
    general_large___small_image_selection__large,
    general_large___small_image_selection__small,
    tablet_image,
    product_name_position,
    text_background_color,
    text_background_opacity,
    product_name_for_display,
    subheadline,
    under_image_bar_color,
    vertical_alignment,
}) => {
    const height =
        getMultiChoice(under_image_bar_show_hide) === 'show'
            ? `calc(100vh - 100px)`
            : `92vh`;
    const breakpoints = useBreakpoint();
    let innerContentPosition = setVerticalPosition(
        getMultiChoice(product_name_position),
        getMultiChoice(vertical_alignment),
        breakpoints
    );

    let horizontalPosition = setHorizontalPosition(
        getMultiChoice(product_name_position),
        breakpoints
    );

    const renderImages = () => {
        let largeImageData =
            general_large___small_image_selection__large?.value[0] &&
            getFluidImageData(general_large___small_image_selection__large);

        let smallImageData =
            general_large___small_image_selection__small?.value[0] &&
            getFluidImageData(general_large___small_image_selection__small);

        let tabletImageData =
            tablet_image?.value[0] && getFluidImageData(tablet_image);

        if (!largeImageData?.source) return null;
        const baseobj = {
            aspectRatio: 1,
            base64: '',
            sizes: '',
            src: '',
            srcSet: '',
        };
        const sources = smallImageData
            ? [
                  {
                      ...smallImageData?.source,
                      media: '(max-width: 576px)',
                  },
                  {
                      ...baseobj,
                      ...tabletImageData?.source,
                      media: '(max-width: 1024px)',
                  },
                  {
                      ...largeImageData?.source,
                      media: '(min-width: 577px)',
                  },
              ]
            : largeImageData?.source;

        return (
            <GatsbyImage
                //@ts-ignore
                fluid={sources}
                className={styles.picture}
                style={{ overflow: 'visible' }}
                imgStyle={{ height: '100vh' }}
                alt={largeImageData?.alt}
                fadeIn={false}
            />
        );
    };

    const textBackgroundColor = getColor(text_background_color);
    const underImageBarShowHide = getMultiChoice(under_image_bar_show_hide);

    return (
        <section className={styles.wrapper} style={{ height: height }}>
            <div
                className={styles.contentContainer}
                style={{ height: '100vh' }}
            >
                {renderImages()}

                {textBackgroundColor && (
                    <div
                        className={styles.bgOverlay}
                        style={{
                            backgroundColor: textBackgroundColor,
                            opacity: text_background_opacity?.value / 100,
                        }}
                    ></div>
                )}
            </div>
            <div
                className={styles.innerContentContainer}
                style={horizontalPosition}
            >
                <div
                    className={styles.innerContent}
                    //@ts-ignore
                    style={innerContentPosition}
                >
                    <h1 className={styles.headline}>
                        <PlainTextElement text={product_name_for_display} />
                    </h1>
                    {subheadline.value && (
                        <h2>
                            <PlainTextElement text={subheadline} />
                        </h2>
                    )}
                </div>
            </div>
            {underImageBarShowHide === 'show' && (
                <div
                    className={styles.underImageBar}
                    style={{
                        //@ts-ignore
                        backgroundColor: getColor(under_image_bar_color),
                    }}
                ></div>
            )}
        </section>
    );
};

export default ProductDetailMasthead;

function setHorizontalPosition(
    contentPosition: ContentPosition,
    breakpoints: MediaQueries
) {
    if (contentPosition == 'center') {
        return { justifyContent: 'center' };
    }

    if (contentPosition == 'right' && breakpoints.md) {
        return { justifyContent: 'flex-end' };
    }

    return { justifyContent: 'flex-start' };
}

function setVerticalPosition(
    contentPosition: ContentPosition,
    verticalAlignment: VerticalPosition,
    breakpoints: MediaQueries
) {
    let width = contentPosition === 'left' ? '100%' : undefined;

    if (verticalAlignment == 'top') {
        return {
            justifyContent: 'flex-start',
            marginTop: '2rem',
            width: width,
        };
    }
    if (verticalAlignment == 'center') {
        return {
            justifyContent: 'center',
            width: width,
        };
    }
    if (verticalAlignment == 'bottom') {
        return {
            justifyContent: 'flex-end',
            width: width,
        };
    }

    return {};
}
